import { render, staticRenderFns } from "./Navcon1.vue?vue&type=template&id=51f8a792&scoped=true&"
import script from "./Navcon1.vue?vue&type=script&lang=js&"
export * from "./Navcon1.vue?vue&type=script&lang=js&"
import style0 from "./Navcon1.vue?vue&type=style&index=0&id=51f8a792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8a792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f8a792')) {
      api.createRecord('51f8a792', component.options)
    } else {
      api.reload('51f8a792', component.options)
    }
    module.hot.accept("./Navcon1.vue?vue&type=template&id=51f8a792&scoped=true&", function () {
      api.rerender('51f8a792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navcon1.vue"
export default component.exports